import type { Resource } from '../../';
export const cart_cartItem_color: Resource = {"default":"Color","en-gb":"Colour"};
